var portfolioSelector = {
	label: "Elegir portafolio"
};
var es = {
	portfolioSelector: portfolioSelector
};

export { es as default, portfolioSelector };
